import styles from "../../styles/components/searchFigma/SearchError.module.css";
import styles2 from "../../styles/components/searchFigma/ResultListItem.module.css";

export default function SearchEmpty({ keyword, isLogin }) {
  const handleQuoteRequest = () => {
    const baseUrl = `/estimate/quote_request?it_name=${keyword}`;
    const loginUrl = `/auth/login?before=${baseUrl}`;
    window.location.href = isLogin === "0" ? loginUrl : baseUrl;
  };

  return (
    <div className={styles.frame02}>
      <div className={styles.frame020}>
        <div className={styles.notfound}>
          {/* ✅ background 대신 실제 이미지 태그 사용 */}
          <img
            src="/images/search/notconnected.png"
            alt="검색 결과 없음"
            className={styles.notfoundImage}
          />
        </div>
      </div>
      <div className={styles.frame021}>
        <div className={`${styles.noContent} title1`}>다시 검색해주세요!</div>
        <div className={`${styles.summary} body2`}>
          일시적인 오류로 서버와 연결이 끊겼습니다. <br />
          페에지를 새로고침 하거나, 다시 한 번 검색해주세요.
        </div>
      </div>
    </div>
  );
}
